module.exports = __webpack_public_path__ + "static/media/ofir.98bec79e.png";